module.exports = __webpack_public_path__ + "img/report-color.cccdc7c2.png";